"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { Field, Shell } from "@/features/home-v2/form/Form";
import { Segmented } from "@/features/home-v2/ui";
import { AmountCard, TokenChip } from "@/features/wallet/v2/dialogs/kit";
import TopUpNotice from "@/features/wallet/v2/TopUpNotice";
import { DURATIONS, usePlaceOffer, type PlaceOfferProps } from "../../flows/usePlaceOffer";
import { CurrencyList, CurrencyRow } from "./CurrencyPick";
import { FlowDialog } from "./FlowDialog";

/** Make an offer, in v2 — every rule is `usePlaceOffer`'s (the legacy `PlaceOfferFlow`). */
export default function OfferDialog(props) {
  const $ = _c(74);
  const f = usePlaceOffer(props);
  const isFa = props.lang === "fa";
  let t0;
  if ($[0] !== isFa) {
    t0 = (fa, en) => isFa ? fa : en;
    $[0] = isFa;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t = t0;
  const [picking, setPicking] = useState(false);
  let t1;
  if ($[2] !== f.currencies || $[3] !== f.selectedCurrencyId) {
    t1 = f.currencies.find(c => String(c.id) === f.selectedCurrencyId)?.image;
    $[2] = f.currencies;
    $[3] = f.selectedCurrencyId;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const image = t1;
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setPicking(true);
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== f.currencies || $[7] !== f.currencyReason || $[8] !== f.selectedCurrencyId || $[9] !== isFa) {
    t3 = <CurrencyRow currencies={f.currencies} value={f.selectedCurrencyId} reason={f.currencyReason} onOpen={t2} isFa={isFa} />;
    $[6] = f.currencies;
    $[7] = f.currencyReason;
    $[8] = f.selectedCurrencyId;
    $[9] = isFa;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const t4 = f.touchAmount;
  let t5;
  if ($[11] !== t) {
    t5 = t("\u0645\u0628\u0644\u063A \u06A9\u0644 \u0622\u0641\u0631", "Total offer amount");
    $[11] = t;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== f.symbol || $[14] !== image || $[15] !== props.fallbackSymbol) {
    t6 = <TokenChip image={image} symbol={f.symbol} placeholder={props.fallbackSymbol} />;
    $[13] = f.symbol;
    $[14] = image;
    $[15] = props.fallbackSymbol;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const t7 = f.amountError ? "error" : undefined;
  let t8;
  if ($[17] !== f.amount || $[18] !== f.amountError || $[19] !== f.setAmount || $[20] !== t5 || $[21] !== t6 || $[22] !== t7) {
    t8 = <AmountCard label={t5} value={f.amount} onChange={f.setAmount} side={t6} message={f.amountError} tone={t7} />;
    $[17] = f.amount;
    $[18] = f.amountError;
    $[19] = f.setAmount;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== f.touchAmount || $[25] !== t8) {
    t9 = <div onBlur={t4}>{t8}</div>;
    $[24] = f.touchAmount;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== f.shortfall || $[28] !== props.lang) {
    t10 = f.shortfall ? <TopUpNotice lang={props.lang} {...f.shortfall} /> : null;
    $[27] = f.shortfall;
    $[28] = props.lang;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== t) {
    t11 = t("\u062A\u0639\u062F\u0627\u062F", "Quantity");
    $[30] = t;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  let t12;
  if ($[32] !== f) {
    t12 = e => f.setQuantity(e.target.value);
    $[32] = f;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  const t13 = Boolean(f.quantityError) || undefined;
  let t14;
  if ($[34] !== f.quantity || $[35] !== t12 || $[36] !== t13) {
    t14 = <Shell ltr={true}><input id="nd-offer-qty" type="text" inputMode="numeric" autoComplete="off" value={f.quantity} onChange={t12} aria-invalid={t13} /></Shell>;
    $[34] = f.quantity;
    $[35] = t12;
    $[36] = t13;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  let t15;
  if ($[38] !== f.quantityError || $[39] !== t11 || $[40] !== t14) {
    t15 = <Field id="nd-offer-qty" label={t11} required={true} error={f.quantityError}>{t14}</Field>;
    $[38] = f.quantityError;
    $[39] = t11;
    $[40] = t14;
    $[41] = t15;
  } else {
    t15 = $[41];
  }
  let t16;
  if ($[42] !== t) {
    t16 = t("\u0645\u062F\u062A \u0627\u0639\u062A\u0628\u0627\u0631", "Expiration");
    $[42] = t;
    $[43] = t16;
  } else {
    t16 = $[43];
  }
  let t17;
  if ($[44] !== t16) {
    t17 = <span className="md-label">{t16}</span>;
    $[44] = t16;
    $[45] = t17;
  } else {
    t17 = $[45];
  }
  let t18;
  if ($[46] !== t) {
    t18 = t("\u0645\u062F\u062A \u0627\u0639\u062A\u0628\u0627\u0631", "Expiration");
    $[46] = t;
    $[47] = t18;
  } else {
    t18 = $[47];
  }
  const t19 = f.duration;
  const t20 = f.setDuration;
  let t21;
  if ($[48] !== isFa) {
    t21 = DURATIONS.map(d => ({
      value: d,
      label: isFa ? `${Number(d).toLocaleString("fa-IR")} روز` : `${d} ${d === "1" ? "day" : "days"}`
    }));
    $[48] = isFa;
    $[49] = t21;
  } else {
    t21 = $[49];
  }
  let t22;
  if ($[50] !== f.duration || $[51] !== f.setDuration || $[52] !== t18 || $[53] !== t21) {
    t22 = <Segmented label={t18} value={t19} onChange={t20} options={t21} />;
    $[50] = f.duration;
    $[51] = f.setDuration;
    $[52] = t18;
    $[53] = t21;
    $[54] = t22;
  } else {
    t22 = $[54];
  }
  let t23;
  if ($[55] !== t17 || $[56] !== t22) {
    t23 = <div className="md-field">{t17}{t22}</div>;
    $[55] = t17;
    $[56] = t22;
    $[57] = t23;
  } else {
    t23 = $[57];
  }
  let t24;
  if ($[58] !== t10 || $[59] !== t15 || $[60] !== t23 || $[61] !== t3 || $[62] !== t9) {
    t24 = <>{t3}{t9}{t10}{t15}{t23}</>;
    $[58] = t10;
    $[59] = t15;
    $[60] = t23;
    $[61] = t3;
    $[62] = t9;
    $[63] = t24;
  } else {
    t24 = $[63];
  }
  const input = t24;
  let t25;
  if ($[64] !== f.currencies || $[65] !== f.selectedCurrencyId || $[66] !== f.setSelectedCurrencyId || $[67] !== isFa || $[68] !== picking) {
    t25 = picking ? <CurrencyList currencies={f.currencies} value={f.selectedCurrencyId} onPick={f.setSelectedCurrencyId} onBack={() => setPicking(false)} isFa={isFa} /> : undefined;
    $[64] = f.currencies;
    $[65] = f.selectedCurrencyId;
    $[66] = f.setSelectedCurrencyId;
    $[67] = isFa;
    $[68] = picking;
    $[69] = t25;
  } else {
    t25 = $[69];
  }
  const overlay = t25;
  let t26;
  if ($[70] !== f.model || $[71] !== input || $[72] !== overlay) {
    t26 = <FlowDialog m={f.model} input={input} overlay={overlay} />;
    $[70] = f.model;
    $[71] = input;
    $[72] = overlay;
    $[73] = t26;
  } else {
    t26 = $[73];
  }
  return t26;
}